// extracted by css-extract-rspack-plugin
export default {"content":"VFgtnGVgM4Ek4Fub","list":"bzQVCMGTRjAtwvXH","item":"yqgk8GrYOAM053pl"};